/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import React from 'react';
import { useField, useFormikContext } from 'formik';
import { TextField } from '@mui/material';
import { useCheckoutStore } from '../../Hooks/Zustand/useCheckoutStore';

/**
 * Form InputField Component
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export function InputField(props) {
  const { ...rest } = props;
  const [field, meta] = useField(props);
  const { updateFormDataValue, setLastValidStep, getActiveStep } = useCheckoutStore();
  const { handleBlur } = useFormikContext();

  /**
     * Handle error
     * @returns {null|string}
     * @private
     */
  function _renderHelperText() {
    const { touched, error } = meta;
    if (touched && error) {
      return error;
    }
    return null;
  }

  /**
     * Handle change
     * @param e
     */
  const combinedOnChange = (e) => {
    if (field.onChange) {
      field.onChange(e);
    }
    setLastValidStep(getActiveStep());
  };

  return (
    <TextField
      type="text"
      error={meta.touched && meta.error && true}
      helperText={_renderHelperText()}
      {...field}
      {...rest}
      onBlur={(event) => {
        handleBlur(event);
        updateFormDataValue(field.name, field.value);
      }}
      onChange={combinedOnChange}
    />
  );
}
